import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { InitializationError } from "./common/errors";

const ELEMENT_ID = "root";

const container = document.getElementById(ELEMENT_ID);
if (container === null) {
  throw new InitializationError(
    `Unable to locate Element with id ${ELEMENT_ID}`,
  );
}
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
